import { ReportAbuseType } from '@ugc-containers/ugc-report-abuse/interfaces';

interface IReportAbuseState {
  isShowReportAbuseModal: boolean;
  reportAbuseReasonList: {
    value: string;
    content: string;
    name: string;
  }[];
  reportAbuseModal: {
    type: ReportAbuseType;
    referenceId: string;
  };
}

const reportAbuse: IReportAbuseState = {
  isShowReportAbuseModal: false,
  reportAbuseReasonList: [],
  reportAbuseModal: {
    type: ReportAbuseType.Review,
    referenceId: '',
  },
};

export default reportAbuse;
